/* eslint-disable no-underscore-dangle */
import $ from 'jquery';

class Expandable {
  init() {
    this.expandable = $('.js-expandable');

    if (!this.expandable.length) {
      return;
    }

    this.expandableToggle();
    this.expandableEntryToggle();
    this.expandableViaHash();

    // let debounce;
    // $(window).on('resize', () => {
    //   clearTimeout(debounce);

    //   debounce = setTimeout(() => {
    //     this.expandableEntryOpacity();
    //   }, 500);
    // });
  }

  expandableEntryOpacity() {
    this.expandableEntry.each((index, elem) => {
      const self = $(elem);
      const content = self.find('.js-expandable-entry-content');
      const innerContentElements = content.find(
        '.js-expandable-entry-content-inner *',
      );

      if (innerContentElements.length) {
        innerContentElements.each((i, el) => {
          const htmlElement = $(el);

          if (htmlElement.text().length) {
            const words = htmlElement.html().split(' ');
            htmlElement.empty();

            $.each(words, (ind, word) => {
              htmlElement.append($('<span class="is-word">').html(`${word} `));
            });
          }
        });

        const word = self.find('.is-word');

        if (word.length) {
          word.each((i, w) => {
            const wordPos = $(w).position().top;
            const limit =
              content.height() - (parseFloat(content.css('line-height')) + 10);

            if (wordPos >= limit) {
              $(w).addClass('is-lighter');
            }
          });
        }
      }
    });
  }

  expandableEntryToggle() {
    this.expandableEntry = $('.js-expandable-entry');

    if (this.expandableEntry.length) {
      // this.expandableEntryOpacity();

      this.expandableEntry.each((index, elem) => {
        const self = $(elem);
        const content = self.find('.js-expandable-entry-content');

        if (content.hasClass('is-toggled')) {
          const initialHeight = content.height();
          const button = self.find('.js-expandable-entry-button');
          const buttonShowLabel = button.text();
          const buttonHideLabel = button.data('hide-label');

          button.on('click', () => {
            const innerContent = content.find(
              '.js-expandable-entry-content-inner',
            );

            content
              .toggleClass('is-open')
              .stop()
              .animate(
                {
                  height: content.hasClass('is-open')
                    ? innerContent.height()
                    : initialHeight,
                },
                400,
                () => {
                  if (content.hasClass('is-open')) {
                    content.addClass('has-opened');
                    button.text(buttonHideLabel);
                  } else {
                    content.removeClass('has-opened');
                    button.text(buttonShowLabel);
                  }
                },
              );
          });
        }
      });
    }
  }

  expandableViaHash() {
    this.hash = window.location.hash;

    if (this.hash) {
      const sectionBtn = this.expandable.find(
        `.js-expandable-list-section-btn[data-target="${this.hash}"]`,
      );

      this.clicked = false;

      if (sectionBtn.length) {
        $('body, html')
          .stop()
          .animate({ scrollTop: sectionBtn.offset().top - 100 }, 400, () => {
            if (!this.clicked && !sectionBtn.hasClass('is-active')) {
              sectionBtn.trigger('click');
              this.clicked = true;
            }
          });
      }
    }
  }

  expandableToggle() {
    this.expandable.each((index, element) => {
      const self = $(element);
      const list = self.find('.js-expandable-list').first();
      const sectionBtn = list.find('.js-expandable-list-section-btn');

      sectionBtn.off('click');
      sectionBtn.on('click', e => {
        const btn = $(e.currentTarget);
        const section = btn
          .closest('.js-expandable-list-section')
          .find(`.js-expandable-list-section-content${btn.data('target')}`);

        if (section.length) {
          if (btn.hasClass('is-active')) {
            btn.removeClass('is-active').attr('aria-expanded', false);
            section.slideUp(300, () => {
              section.removeClass('is-open');
            });
          } else {
            btn.addClass('is-active').attr('aria-expanded', true);
            section
              .slideDown(300, () => {
                const tableau = section.find(
                  '.c-river-graph .tableauPlaceholder',
                );

                if (tableau.length && window.tableau.vizs !== 'undefined') {
                  setTimeout(() => {
                    const viz =
                      window.tableau.vizs[window.tableau.vizs.length - 1];

                    if (viz) {
                      if (tableau.length) {
                        const height = tableau[0].offsetWidth * 0.75;
                        tableau.css({ height: `${height}px` });
                        tableau.find('iframe').css({ height: `${height}px` });
                        viz.refresh();
                      }
                    }
                  }, 250);
                }
              })
              .addClass('is-open');
          }
        }
      });
    });
  }
}

export default Expandable;



// WEBPACK FOOTER //
// ./src/scripts/modules/expandable.js